import React from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import './Wiki.css';

const ArticleView = ({ article, onBack }) => {
  return (
    <main className="technical-page technical-page--article">
      <article className="technical-article-view">
        <button type="button" onClick={onBack} className="technical-page__back">
          <FaArrowLeft aria-hidden="true" />
          Back to Search
        </button>

        <header className="technical-article-view__header">
          <img
            src={require(`../../assets/wikiImages/${article.image}`)}
            alt=""
            aria-hidden="true"
          />
          <div>
            <p className="technical-page__eyebrow">Technical Archive</p>
            <h1>{article.title}</h1>
          </div>
        </header>

        <div
          className="technical-article-view__body"
          dangerouslySetInnerHTML={{ __html: article.content }}
        />
      </article>
    </main>
  );
};

export default ArticleView;
